<template>
<div class="vcenter">
  <div style="fontSize: 24px;"> Enter Token </div>
  <el-input  v-model="softToken" style="width:200px"></el-input><br><br>
  <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="onSubmit">Submit</el-button><br>
  <br>
  <div style="fontSize: 16px;"> OR</div><br>
  <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c;" @click="sendEmail()">Receive Token by Email</el-button><br>
</div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import MFA_HTTP_API from '@/utils/mfa-http-api'
import HTTP_API from '@/utils/http-api'
import PRE_HTTP_API from '@/utils/pre-http-api'

export default({
  name: 'SoftToken',
   data() {
     return {
      softToken: '',
      lenderId:''
    }
   },
  methods: {
    onSubmit(){
      var vm= this;
      MFA_HTTP_API.post('/auth/verifycode', vm.softToken).then(response => {
        var verified = response.data.verified;
        var errorMsg = response.data.error;

        if (verified == true){
          PRE_HTTP_API.post('/auth/mfatoken').then(response => {
            sessionStorage.removeItem('pre-web-token')

            var expDate = new Date();
            let expDateStorage = expDate.getTime() + (response.data.expires_in*1000) - (60*1000);
            sessionStorage.setItem('expDate',expDateStorage)
            sessionStorage.setItem('web-token',response.data.access_token)
            
            vm.userAdditionalInfo()
          })
        } else {
          vm.$message.error({ message: errorMsg })
        }
      }).catch(function (error) {
        console.log(error)
        var token = sessionStorage.getItem('pre-web-token')
        if (token) {
          vm.$message.error({ message: 'System Error. Please contact Client Relationship team.' })
        }else{
          vm.$message.error({ message: 'Your session expired. Please login again.' })
        }
      })
    },
    userAdditionalInfo(){
      var vm = this
      HTTP_API.get('/base/useradditionalinfo')
      .then(response => {
        vm.lenderId =  response.data
        vm.getCusipAgreementDate()
      })
      .catch(function (error) {
        console.log(error.response)
      })
    },
    getCusipAgreementDate(){
      var vm = this
      HTTP_API.get('/account/cusipagreementdate')
      .then(response => {
       var cusipDate = response.data;
       if(cusipDate === null || !cusipDate){
          vm.$router.push({ name: "cusipagreement"})
       } else {
          vm.$router.push({ name: "home",params: {lenderId: parseInt(vm.lenderId)} })
       }
      })
      .catch(function (error) {
        console.log(error.response)
      })
    },
    sendEmail() {
      var vm = this
      MFA_HTTP_API.post('/auth/generateotpcode').then(response => {
        vm.$message.success({ message: 'Token sent successfully.' })

      })
      .catch(function (error) {
        console.log(error.response)
        var token = sessionStorage.getItem('pre-web-token')
        if (token) {
          vm.$message.error({ message: 'Error in sending token.' })
        }else{
          vm.$message.error({ message: 'Your session expired. Please login again.' })
        }
      })
    }
  }
})
</script>

<style scoped>
.vcenter {
  position: absolute;
  margin: 0;
  top: 45%;
  left: 50%;
  -ms-transform: translate(-50%, -47%);
  transform: translate(-50%, -47%);
  width: 300px;
  color: #606266;
  background-color: #f2f2f2;
  border-radius: 5px;
  padding: 22px 22px;
  /* background: rgba(255, 255, 255, .9); */
  opacity: 0.96;
  box-shadow: 0 2px 6px 1px #666666;
  text-align: center;
}
</style>
